export default "__VITE_ASSET__6d39ec64__"